export default ({ palette, formComponents }) => ({
  root: {
    marginBottom: formComponents.container.marginBottom,
    display: 'block'
  },
  inline: {
    display: 'flex',
    borderRadius: 0
  },
  block: {
    flex: '1'
  },
  label: {
    justifyContent: 'center',
    alignSelf: 'center'
  },
  number: {
    marginBottom: 0,
    display: 'flex',
    '& input': {
      ...formComponents.numberInput,
      borderRightColor: 'transparent',
      '-moz-appearance': 'textfield'
    },
    '& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  btnCtrl: {
    display: 'inline-block',
    width: 35,
    border: `1px solid ${palette.form.border}`,
    color: palette.primary.normal,
    backgroundColor: formComponents.input.backgroundColor,
    borderRadius: [0, 2, 2, 0]
  },
  btnPlus: {
    borderRadius: [0, 2, 2, 0]
  },
  btnMinus: {
    marginRight: -1,
    borderRadius: [2, 0, 0, 2]
  }
});
